$(document).ready(function(){
  $(".data.item.title").click(function(){
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next('.content').removeClass('active');
    }
    else {
      $(".data.item.title").removeClass('active');
      $(".data.item.content").removeClass('active');
      $(this).addClass('active');
      $(this).next('.content').addClass('active');
    }
  });
});